































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { teamCheck } from '@/api/team/team'
import { SERVER_HOST } from '@/global/constants';

@Component
export default class ExamRecord extends Vue {
    private dataList: object[] = [];
    private total: number | string = 0;
    private task: object = {};
    private searchParams: object = {
        tid:'',
        uid:'',
        date:'',
        page: '1',
        pagesize: '20',
    };
    private sum:any = {};
    private columnsSchema: object[] = [
        {
            title: '任务编号',
            key: 'tsid',
            align: 'center',
        },
        {
            title: '任务名称',
            key: 'title',
            align: 'center',
        },
        {
            title: '成员ID',
            key: 'uid',
            align: 'center',
        },
        {
            title: '通过数量',
            key: 'csnums',
            align: 'center',
        },
        {
            title: '拒绝数量',
            key: 'cfnums',
            align: 'center',
        },
        {
            title: '通过率',
            slot: 'rate',
            align: 'right',
        },
        {
            title: '日期',
            key: 'data',
            align: 'center',
        },
    ];
    @Watch('$route')
    private routechange(to: any, from: any) {
        if (to.name == 'statistics') {
            this.getList();
        }
    }
    private created() {
        this.getList()
    }
    private async getList() {
        let params: any = JSON.parse(JSON.stringify(this.searchParams))
        try {
            const data = (await teamCheck(params)) as any;
            this.$nextTick(() => {
                this.dataList = data.rows;
                this.total = data.total;
                this.sum = data.sum;
            });
        } catch (error) {
            console.log(error);
        }
    }
    // 搜索
    private handleSearch() {
        this.getList();
    }
    // 日期选择器
    private handleChange(date){
        (this.searchParams as any).date = date
    }
    // 分页
    private changePage(data) {
        this.searchParams = Object.assign(this.searchParams, {
            page: data,
        });
        this.getList();
    }
    // 重置
    private handlereset() {
        this.searchParams = {
            tid:'',
            uid:'',
            date:'',
            page: '1',
            pagesize: '20',
        };
        this.getList();
    }
    // 导出
    private handlerExport(){
        let data:any = this.searchParams;
        if(data !== undefined){
            window.open(`${SERVER_HOST}/v1/team/offline/leader/tags/export/check.html?t=1${data.tid ? `&tid=${data.tid}` : ''}${data.uid ? `&uid=${data.uid}` : ''}${data.date ? `&date=${data.date}` : ''}`);
        }
    }
}
